import { useRef } from "react";
import { Drawer, Input, Button } from "antd";
import { TeamOutlined, CloseOutlined } from "@ant-design/icons";

const WaitlistDrawer = ({
  waitlistDrawerOpen,
  setWaitlistDrawerOpen,
  waitlistTab,
  setWaitlistTab,
  waitlistForm,
  setWaitlistForm,
  waitlistErrors,
  saveToWaitlist,
  numbers,
  handleWaitlistContactSearch,
  phoneError,
  waitlistSubmitting,
}) => {
  const waitlistNameRef = useRef(null);

  return (
    <Drawer
      open={waitlistDrawerOpen}
      onClose={() => setWaitlistDrawerOpen(false)}
      width="80%"
      styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
      styles={{ body: {
        padding: "0px 30px",
        background: "#fff",
        height: "100%",
        overflow: "auto",
      } }}
      styles={{ header: { display: "none" } }}
    >
      {/* Close Icon */}
      <div
        style={{
          position: "absolute",
          right: 20,
          top: 20,
          cursor: "pointer",
          fontSize: 18,
          color: "#444",
          zIndex: 10,
        }}
        onClick={() => setWaitlistDrawerOpen(false)}
      >
        <CloseOutlined />
      </div>

      <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 10, marginTop: 15 }}>
        Waitlist & Queue Management
      </h1>

      {/* --------- TOGGLE BUTTONS --------- */}
      <div
        style={{
          display: "flex",
          background: "#F4F4F5",
          borderRadius: 10,
          marginBottom: 20,
          padding: 4,
        }}
      >
        <div
          onClick={() => setWaitlistTab("add")}
          style={{
            flex: 1,
            padding: "10px 0",
            textAlign: "center",
            background: waitlistTab === "add" ? "#fff" : "transparent",
            fontWeight: waitlistTab === "add" ? 600 : 500,
            fontSize: 14,
            borderRadius: 8,
            cursor: "pointer",
            color: waitlistTab === "add" ? "#000" : "#6B7280",
            boxShadow: waitlistTab === "add" ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
          }}
        >
          Add to Waitlist
        </div>
      </div>

      {/* ---------------- SHOW ADD FORM ---------------- */}
      {waitlistTab === "add" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 130px)",
          }}
        >
          {/* SCROLLABLE FORM */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              paddingRight: 10,
              paddingBottom: 20,
            }}
          >
            {/* Contact Number */}
            <div style={{ marginBottom: 15 }}>
              <label style={{ fontSize: 14, fontWeight: 600 }}>Contact Number *</label>
              <Input
                placeholder="Enter 10-digit mobile"
                size="large"
                style={{
                  borderRadius: 8,
                  marginTop: 6,
                  borderColor: phoneError ? "#ff4d4f" : undefined,
                }}
                value={waitlistForm.phone}
                onChange={handleWaitlistContactSearch}
                onKeyPress={(e) => {
                  if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
                }}
              />
              {phoneError && (
                <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 4 }}>{phoneError}</div>
              )}
            </div>

            {/* Guests */}
            <div style={{ marginBottom: 15 }}>
              <label style={{ fontSize: 14, fontWeight: 600 }}>How Many Guests *</label>
              <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap", gap: 10 }}>
                {numbers?.map((num, i) => {
                  const isSelected = waitlistForm?.guests === num;
                  return (
                    <div
                      key={i}
                      onClick={() => setWaitlistForm((prev) => ({ ...prev, guests: num }))}
                      style={{
                        padding: "10px 18px",
                        borderRadius: 10,
                        cursor: "pointer",
                        border: isSelected ? "2px solid #2F3856" : "1px solid #ccc",
                        background: isSelected ? "#2F3856" : "#fff",
                        color: isSelected ? "#fff" : "#000",
                        fontWeight: 600,
                        minWidth: 55,
                        textAlign: "center",
                      }}
                    >
                      {num}
                    </div>
                  );
                })}
              </div>
              {waitlistErrors.guests && (
                <p style={{ color: "red", marginTop: 6 }}>{waitlistErrors.guests}</p>
              )}
            </div>

            {/* Name */}
            <div style={{ marginBottom: 15 }}>
              <label style={{ fontSize: 14, fontWeight: 600 }}>Guest Name *</label>
              <Input
                placeholder="Enter guest name"
                size="large"
                style={{ borderRadius: 8, marginTop: 6 }}
                ref={waitlistNameRef}
                value={waitlistForm.name}
                onChange={(e) => setWaitlistForm({ ...waitlistForm, name: e.target.value })}
                status={waitlistErrors.name ? "error" : ""}
              />
              {waitlistErrors.name && (
                <p style={{ color: "red", marginTop: 4 }}>{waitlistErrors.name}</p>
              )}
            </div>

            {/* ETA */}
            <div>
              <label style={{ fontSize: 14, fontWeight: 600 }}>
                Estimated Wait Time (minutes)
              </label>
              <Input
                placeholder="15"
                size="large"
                style={{ borderRadius: 8, marginTop: 6 }}
                value={waitlistForm.eta}
                onChange={(e) => setWaitlistForm({ ...waitlistForm, eta: e.target.value })}
                status={waitlistErrors.eta ? "error" : ""}
              />
              {waitlistErrors.eta && (
                <p style={{ color: "red", marginTop: 4 }}>{waitlistErrors.eta}</p>
              )}
            </div>
          </div>

          {/* FIXED BUTTON AT BOTTOM */}
          <div style={{ background: "#fff", borderTop: "1px solid #E5E7EB" }}>
            <Button
              type="primary"
              size="large"
              icon={<TeamOutlined />}
              disabled={waitlistSubmitting}
              loading={waitlistSubmitting}
              style={{
                width: "100%",
                height: 45,
                background: "#2F3856",
                borderRadius: 10,
                fontWeight: 500,
                marginBottom: "10px",
              }}
              onClick={saveToWaitlist}
            >
              Add to Waitlist
            </Button>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default WaitlistDrawer;
